import { atomWithBroadcast } from '../core';

export const userMoneyVisibleAtom = atomWithBroadcast<boolean>('settings/userMoneyVisible', true);
